import { Component, OnInit, inject } from '@angular/core';
import { WebdokuService } from '../webdoku.service';
import { SelectionArguments } from '../../shared/models/selection-arguments';
import { SelectionType } from '../../shared/enums/selection-type';
import { Webdoku } from '../../shared/models/webdoku';
import { InfoService } from '../../shared/services/info.service';
import { LdwRouterService } from '../../route/ldw-router.service';
import { MenuService } from '../../shell/menu.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ldw-webdoku-page',
    templateUrl: './webdoku-page.component.html',
    styleUrls: ['./webdoku-page.component.css'],
    standalone: false
})
export class WebdokuPageComponent implements OnInit {
  private wdService = inject(WebdokuService);
  private infoService = inject(InfoService);
  private ldwRouterService = inject(LdwRouterService);

  webDokus?: Webdoku[] = undefined;

  constructor() {
    this.infoService.clearStatus();
  }

  ngOnInit(): void {
    this.wdService.allWebDokus$.subscribe((res) => {
      this.webDokus = res;
      this.infoService.setLoadedItems(this.webDokus.length);
    });
  }

  onWebDokuSelected(args: SelectionArguments) {
    console.log('webdoku selected');
    if (args != undefined && args.action == SelectionType.Selected) {
      this.wdService.selectWebDoku(args.id).subscribe((res) => {
        if (res) {
          console.log('webdoku selected ok');
          this.ldwRouterService.navigateToDocumentsRoot();
        } else {
          console.log('webdoku selected fails');
          this.ldwRouterService.errorStop('WEBDOKUSELECTERROR');
        }
      });
    }
  }
}
